export type CountryCode = 'KG' | 'KZ' | 'US' | 'RU'
export function getPhoneNumberMask(countryCode?: CountryCode) {
  let numberFormat
  let phoneNumberCode

  switch (countryCode) {
    case 'KG':
      numberFormat = '+996 (111) 111-111'
      phoneNumberCode = '+996'
      break
    case 'KZ':
      numberFormat = '+7 (111) 111-1111'
      phoneNumberCode = '+7'
      break
    case 'US':
      numberFormat = '+1 (111) 111-1111'
      phoneNumberCode = '+1'
      break
    case 'RU':
      numberFormat = '+7 (111) 111-11-11'
      phoneNumberCode = '+7'
      break
    default:
      numberFormat = '+996 (111) 111-111'
      phoneNumberCode = '+996'
  }

  return { numberFormat, phoneNumberCode }
}
